// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generalContainer_yvpJ8 {
  height: fit-content;
  position: relative;
}
.labelGeneral_DNaC4 {
  display: flex;
  padding: 11px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-bottom: 1px solid var(--eb-border);
  input {
    border: none;
    outline: none;
    font-size: 14px;
    font-weight: 400;
    color: var(--_807d7d-color);
    min-height: 21px;
    background-color: var(--f4-background);
    border-radius: 5px;
    box-sizing: border-box;
    width: 100%;
    padding: 12px;
  }
  .row_vO1Ob {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;



    p {
      margin: 0;
    }
    .colors_XJAuq {
      display: flex;
      align-items: center;
      gap: 10px;
      .color_QsNz3 {
        cursor: pointer;
        width: 42px;
        height: 24px;
        flex-shrink: 0;
        border-radius: 9999px;
      }
    }
    >div{
      cursor: default;
    }
    .currencyDropdown_RynHR{
      cursor: pointer;
    }
  }

  .editButton_mcOn1{
    opacity: 0;
    display: flex;
    justify-content: end;
  }

  &:hover{
    .editButton_mcOn1{
      opacity: 1;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/GeneralSettings/components/Speech/speech.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,yCAAyC;EACzC;IACE,YAAY;IACZ,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;;;;IAIX;MACE,SAAS;IACX;IACA;MACE,aAAa;MACb,mBAAmB;MACnB,SAAS;MACT;QACE,eAAe;QACf,WAAW;QACX,YAAY;QACZ,cAAc;QACd,qBAAqB;MACvB;IACF;IACA;MACE,eAAe;IACjB;IACA;MACE,eAAe;IACjB;EACF;;EAEA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE;MACE,UAAU;IACZ;EACF;AACF","sourcesContent":[".generalContainer {\n  height: fit-content;\n  position: relative;\n}\n.labelGeneral {\n  display: flex;\n  padding: 11px 0px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  border-bottom: 1px solid var(--eb-border);\n  input {\n    border: none;\n    outline: none;\n    font-size: 14px;\n    font-weight: 400;\n    color: var(--_807d7d-color);\n    min-height: 21px;\n    background-color: var(--f4-background);\n    border-radius: 5px;\n    box-sizing: border-box;\n    width: 100%;\n    padding: 12px;\n  }\n  .row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 100%;\n\n\n\n    p {\n      margin: 0;\n    }\n    .colors {\n      display: flex;\n      align-items: center;\n      gap: 10px;\n      .color {\n        cursor: pointer;\n        width: 42px;\n        height: 24px;\n        flex-shrink: 0;\n        border-radius: 9999px;\n      }\n    }\n    >div{\n      cursor: default;\n    }\n    .currencyDropdown{\n      cursor: pointer;\n    }\n  }\n\n  .editButton{\n    opacity: 0;\n    display: flex;\n    justify-content: end;\n  }\n\n  &:hover{\n    .editButton{\n      opacity: 1;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"generalContainer": `generalContainer_yvpJ8`,
	"labelGeneral": `labelGeneral_DNaC4`,
	"row": `row_vO1Ob`,
	"colors": `colors_XJAuq`,
	"color": `color_QsNz3`,
	"currencyDropdown": `currencyDropdown_RynHR`,
	"editButton": `editButton_mcOn1`
};
export default ___CSS_LOADER_EXPORT___;
